<template>
  <el-badge :offset="[-3, 3]" :is-dot="(badgeValue || 0) > 0">
    <button
      :class="[mode === 'full' ? 'building-btn' : 'square-btn']"
      size="large"
      :disabled="disabled"
      @click="() => emit('handleClick')"
    >
      <div class="container">
        <img :src="iconPath" alt="icon" />
        <span v-if="mode === 'full' && text">{{ text }}</span>
      </div>
    </button>
  </el-badge>
</template>

<script setup lang="ts">
type ButtonMode = 'full' | 'compact';

const { icon, text, mode } = defineProps<{
  icon: string;
  mode: ButtonMode;
  text?: string;
  badgeValue?: number;
  disabled?: boolean;
}>();

const emit = defineEmits(['handleClick']);

const PNG_ICONS = ['expedition'];
const iconPath = computed(() => {
  const iconKey = icon;
  if (PNG_ICONS.includes(iconKey)) {
    return `/img/icons/${iconKey}.png`;
  }
  return `/img/icons/${iconKey}.svg`;
});
</script>

<style lang="scss" scoped>
button {
  &:disabled {
    .container {
      opacity: 0.3;
    }
  }
}
.container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.building-btn {
  background: linear-gradient(to bottom, #0083ad, #00354f);
  width: 160px;
  border: 1px solid #3b7285;
  color: white;
  transition: width 0.5s;

  span {
    padding-left: 6px;
    font-size: 14px;
  }
}

.square-btn {
  background: linear-gradient(to bottom, #040f14, #081b25);
  width: 48px;
  border: 1px solid #016b79;
  transition: width 0.5s;
}

.building-btn,
.square-btn {
  overflow: hidden;
  border-radius: 12px;
  height: 48px;

  img {
    width: 27px;
    height: 27px;
  }
}
</style>
